<odx-modal-header>
  <odx-area-header i18n="@@imageUploadModal.title">Bild hochladen</odx-area-header>
</odx-modal-header>

<odx-modal-content>
  <div class="image-wrapper">
    <app-standard-image [imageUrl]="imageUploadForm.value.imageUrl ?? undefined"></app-standard-image>
  </div>

  <form odxForm [formGroup]="imageUploadForm" (ngSubmit)="onSubmit()" id="imageUploadForm">
    @if ((isMonitoringScope$ | async) === true) {
      <odx-form-group odxLayout="2@phone 1">
        <odx-form-field i18n-label="@@imageUploadModal.formLocation.label" label="Ort" odxLayout="6@phone 12">
          <input formControlName="name" type="string" odxFormFieldControl />

          <ng-template odxFormFieldError="required" i18n="@@imageUploadModal.formLocation.required"
            >Ort ist ein Pflichtfeld</ng-template
          >
        </odx-form-field>

        <odx-form-field label="Tags" odxLayout="6@phone 12">
          <odx-select multiple formControlName="tags" odxFormFieldControl>
            @for (item of tagList$ | async | odxAutocompleteSearchFilter; track item) {
              <odx-select-option [value]="item">
                {{ item | translateProjectImageTag }}
              </odx-select-option>
            }
            <input
              placeholder="Nach Tag suchen..."
              i18n-placeholder="@@imageUploadModal.formTags.placeholder"
              odxSelectSearchField="Kein Tag gefunden"
              i18n-odxSelectSearchField="@@imageUploadModal.formTags.noResult"
            />
          </odx-select>
        </odx-form-field>
      </odx-form-group>
    }

    @if ((isFgdsScope$ | async) === true) {
      <odx-form-field i18n-label="@@imageUploadModal.formName.label" label="Name" odxLayout="6@phone 12">
        <input formControlName="name" type="string" odxFormFieldControl />

        <ng-template odxFormFieldError="required" i18n="@@imageUploadModal.formName.required"
          >Name ist ein Pflichtfeld</ng-template
        >
      </odx-form-field>
    }

    @if ((isMonitoringScope$ | async) === true) {
      <odx-form-field i18n-label="@@imageUploadModal.formDescription.label" label="Beschreibung">
        <textarea formControlName="description" odxFormFieldControl></textarea>
      </odx-form-field>
    }
  </form>
</odx-modal-content>

<odx-modal-footer [class.project-photos-upload-footer]="isProjectPhotosMobileModal">
  <button
    odxButton
    variant="secondary"
    odxModalDismiss
    class="secondary-button"
    [class.project-photos-upload-footer__button]="isProjectPhotosMobileModal"
    i18n="@@global.dismiss"
  >
    Abbrechen
  </button>
  <button
    odxButton
    variant="primary"
    type="submit"
    form="imageUploadForm"
    [disabled]="imageUploadForm.invalid"
    class="primary-button"
    [class.project-photos-upload-footer__button]="isProjectPhotosMobileModal"
    i18n="@@imageUploadModal.formSubmit"
  >
    Hochladen
  </button>
</odx-modal-footer>
